<div class="entity-detail">
  <nav class="u-m-b-16">
    <ul class="breadcrumbs">
      <li><a routerLink="/job-status/search">Job Status</a></li>
      <li>
        <span>{{ (jobStatusResult$ | async).jobStatus?.jobName }}</span>
      </li>
    </ul>
  </nav>
  <header class="row u-m-b-40">
    <div class="columns">
      <opus-job-status-header [jobStatusResult]="(jobStatusResult$ | async).jobStatus"></opus-job-status-header>
    </div>
  </header>
  <div class="row">
    <div class="columns">
      <div class="u-m-b-16">
        Status: <span>{{ getJobStateName((jobStatusResult$ | async).jobStatus?.state) }}</span>
      </div>
      <div class="u-m-b-16">
        <span class="">Trigger Type:</span> <span>{{ getTriggerTypeName((jobStatusResult$ | async).jobStatus?.triggerType) }}</span>
      </div>
      <div class="u-m-b-16">
        <span class="">Created Date:</span><span>{{ (jobStatusResult$ | async).jobStatus?.createdAt | date : 'MM/dd/yyyy hh:mm:ss a' }}</span>
      </div>
      <div class="u-m-b-16">
        <span class="">Started Date:</span> <span>{{ (jobStatusResult$ | async).jobStatus?.startedAt | date : 'MM/dd/yyyy hh:mm:ss a' }}</span>
      </div>
      <div class="u-m-b-16">
        <span class="">Completed Date:</span><span>{{ (jobStatusResult$ | async).jobStatus?.completedAt | date : 'MM/dd/yyyy hh:mm:ss a' }}</span>
      </div>
      <div class="u-m-b-16">
        <span class="">Message:</span>
        <span *ngIf="splitMessage((jobStatusResult$ | async).jobStatus?.message).length <= 1">{{ (jobStatusResult$ | async).jobStatus?.message }}</span>
        <ul *ngIf="splitMessage((jobStatusResult$ | async).jobStatus?.message).length > 1">
          <li *ngFor="let message of splitMessage((jobStatusResult$ | async).jobStatus?.message)">
            <span>{{ message }}</span>
          </li>
        </ul>
      </div>
    </div>
  </div>

  <div class="u-m-b-16 typography--title">Logs:</div>

  <aside class="card">
    <div class="card__section">
      <div class="row">
        <div class="columns">
          <ul>
            <li *ngFor="let log of (jobStatusResult$ | async).jobStatus?.jobLogs">
              <strong>[{{ log.createdAt | date : 'MM/dd/yyyy hh:mm:ss a' }} {{ getLogLevelName(log.level) }} - {{ log.source }}]:</strong>
              <ul *ngIf="splitMessage(log.message).length > 1">
                <li *ngFor="let messagePart of splitMessage(log.message)">{{ messagePart }}</li>
              </ul>
              <span *ngIf="splitMessage(log.message).length <= 1">{{ log.message }}</span>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </aside>
</div>
